// extracted by mini-css-extract-plugin
module.exports = {"attachment-item":"attachment-item--iiVpVvSh","file-item":"file-item--1z3nBQns","attachment-toolbar-wrapper":"attachment-toolbar-wrapper--bMRUtVbE"};